import axios, {
  _get,
  _post,
  _postParams,
  _put,
  _patch,
  _delete,
  _putParams,
} from "./index";

// 用户登录
export const login = (data: any) => {
  const req = {
    data,
    url: "zstapi/members/userLogin",
  };
  return _postParams(req);
};

// 用户注册
export const regist = (data: any) => {
  const req = {
    data,
    url: "zstapi/members/register",
  };
  return _post(req);
};
// 用户登录之后获取信息
export const getUserInfo = (data: any) => {
  const req = {
    method: "get",
    data,
    url: "zstapi/members",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  // @ts-ignore
  return axios(req);
};
// 退出登录
export const toLogOut = (data: any) => {
  const req = {
    data,
    url: "zstapi/members/logout",
    headers: {
      "Content-Type": "application/json",
    },
  };
  return _post(req);
};
// 短信登录
export const loginPhone = (data: any) => {
  const req = {
    data,
    url: "zstapi/members/smsLogin",
  };
  return _postParams(req);
};
// 注册
export const loginOrRegister = (data: any) => {
  const req = {
    data,
    url: "zstapi/members/register",
  };
  return _postParams(req);
};

// 获得短信(无验证)
export const mail_code_unvalid = (data: any) => {
  // const req = {
  //   data,
  //   url: 'zst/user/common/getNotVerifyMessage',
  // };
  // return _get(req);
  const req = {
    data,
    url: "zst/user/sendMessage",
  };
  return _post(req);
};
export const getExtraInfo = (data: any) => {
  const req = {
    data,
    url: "zst/page/unit/getUnitSupplement",
  };
  return _get(req);
};
export const addExtraInfo_center = (data: any) => {
  const req = {
    data,
    url: "zst/page/unit/consoleUpdateAndAdd",
  };
  return _post(req);
};
export const addExtraInfo_home = (data: any) => {
  const req = {
    data,
    url: "zst/page/unit/quickMatchUpdateAndAdd",
  };
  return _post(req);
};
// 修改手机号
export const update_phone = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/updateUserPhone",
  };
  return _put(req);
};
// 修改密码
export const update_password = (data: any) => {
  // const req = {
  //   data,
  //   url: 'zst/page/user/updatePassword',
  // };
  // return _get(req);
  const req = {
    data,
    url: "zstapi/members/resetByMobile",
  };
  return _postParams(req);
};
// 企业实名认证
export const authern_unit = (data: any) => {
  const req = {
    method: "put",
    data,
    url: "zstapi/members/authenticationCompany",
    headers: {
      "Content-Type": "application/json",
    },
  };
  // @ts-ignore

  return axios(req);
};
// 用户实名认证
export const authern_person = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/userReal",
  };
  return _post(req);
};
// 判断密码是否正确
export const judge_password = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/judgePassword",
  };
  return _post(req);
};
// 获取实名信息
export const data_authern = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/getBayUnitSole",
  };
  return _get(req);
};
// 获取实名信息
export const data_authern_person = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/getUnitSole",
  };
  return _get(req);
};
// 获取基本信息
export const data_basic = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/getCode",
  };
  return _get(req);
};
// 保存基本信息
export const add_basic = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/addUnitCode",
  };
  return _post(req);
};
// 获取申报员列表数据
export const list_applicant = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/pageDeclareStaff",
  };
  return _get(req);
};
export const delete_subscribe = (id: any) => {
  const req = {
    data: { id },
    url: "zst/page/user/subscribe/delete",
  };

  return _post(req);
};
// 添加申报员相关
export const add_applicant = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/adDeclare",
  };
  return _post(req);
};
// 修改申报员账号信息
export const update_applicant = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/updateDeclare",
  };
  return _patch(req);
};
// 删除申报员
export const delete_applicant = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/work/deleteDeclare",
  };
  return _get(req);
};
// 关注
export const star = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/attention",
  };
  return _post(req);
};
// 取消关注
export const unStar = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/cancelStar",
  };
  return _post(req);
};
// 添加订阅
export const addSubscribe = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/add",
  };
  return _post(req);
};

export const updateSubscribe = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/subscribe/updateSubscribe",
  };
  return _post(req);
};
// 查询订阅
export const getSubscribeList = (data: any) => {
  const req = {
    data,
    url: "zst/page/user/subscribe/getUserSubscribe",
  };
  return _post(req);
};
// 查询订阅
export const getSubscribeSetList = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/pageList",
  };
  return _get(req);
};
// 百度ocr校验（上传身份证和营业执照时）
export const baiduOcr = (data: any) => {
  const req = {
    data,
    url: "zst//user/file/baidu-ocr",
  };
  return _post(req);
};
// 获取认证信息
export const getCompany = (data: any) => {
  const req = {
    data,
    url: "/zstapi/members/getCompany",
  };
  return _get(req);
};
// 获取企业信息补充
export const getCompanySupplement = (data: any) => {
  const req = {
    data,
    url: "/zstapi/members/getCompanySupplement",
  };
  return _get(req);
};
// 保存企业信息补充
export const saveCompanySupplement = (data: any) => {
  const req = {
    method: "post",
    data,
    url: "/zstapi/members/saveCompanySupplement",
    headers: {
      "Content-Type": "application/json",
    },
  };
  // @ts-ignore
  return axios(req);
};
// 删除
export const deleteSubscribe = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/delete",
  };
  return _delete(req);
};
// 启用-禁用
export const enableOrDisable = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/enableOrDisable",
  };
  return _put(req);
};
export const getDetailById = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/getDetailById",
  };
  return _get(req);
};
export const updateItem = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/update",
  };
  return _put(req);
};
export const enableList = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/enableList",
  };
  return _get(req);
};
export const getDataList = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/adminSubscribe/getDataList",
  };
  return _get(req);
};
export const declareItemApply = (data: any) => {
  const req = {
    data,
    url: "zstapi/data/declare/declareItemApply",
  };
  return _post(req);
};

// 用户登录之后获取信息
export const declareItemAdd = (data: any) => {
  const req = {
    method: "post",
    data,
    url: "zstapi/data/userDeclareItem/add",
    headers: {
      "Content-Type": "application/json",
    },
  };
  // @ts-ignore
  return axios(req);
};